import styled from 'styled-components';
import { Icon, Label, Link, H1 } from 'next/components/ui';

export const ThemeLabelWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  ${Label} {
    padding: 0;
    flex-grow: 1;
  }

  ${Link} {
    display: flex;
    align-items: center;
  }

  ${Icon} {
    margin-left: 8px;
    width: 12px;
  }
`;

export const PinName = styled(H1)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PinNameWrapper = styled.div`
  display: inline-grid;
  max-width: 80%;
`;
